export default "__VITE_ASSET__a1c3GA95__"